import { render } from "./AddBookCloudFunctionView.vue?vue&type=template&id=2d11fcc6"
import script from "./AddBookCloudFunctionView.vue?vue&type=script&lang=js"
export * from "./AddBookCloudFunctionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__